import ReactGA from 'react-ga4'

const MEASUREMENT_ID = 'G-CHDGQ4NF20'
let initialized = false

/** Initializes GA4 once; route changes are recorded separately for this SPA. */
export function initializeAnalytics() {
  if (initialized || typeof window === 'undefined') return

  ReactGA.initialize(MEASUREMENT_ID, {
    gtagOptions: { send_page_view: false },
  })
  initialized = true
}

/** Records every client-side route change as one GA4 page view. */
export function trackPageView(path: string) {
  if (!initialized) return

  ReactGA.send({
    hitType: 'pageview',
    page: path,
    title: document.title,
  })
}
